var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.navigateItem, params: { id: _vm.navigateParam } }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isActive = ref.isActive;
var navigate = ref.navigate;
return [_c('div',{staticClass:"item-nav",class:{'active': isActive },on:{"click":navigate}},[_c('v-icon',{staticClass:"mr-3",attrs:{"size":"24","color":isActive ? '#994995': '#aed0d9'}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.item)+" ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }